import { connect }      from 'react-redux';
import { closeMessage } from './../actions/MessageAction';
import Message          from './../components/Message';

const mapStateToProps = (state) => {
    return {
        message: state.message
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        close: () => {
            dispatch(closeMessage());
        }
    }
};

const MessageContainer = connect(mapStateToProps, mapDispatchToProps)(Message);

export default MessageContainer;



// WEBPACK FOOTER //
// ./src/containers/MessageContainer.js